import * as Popper from '@popperjs/core'
window.Popper = Popper
import * as bootstrap from 'bootstrap';

import './utils';
import './editable-table';

import './user/bg_colors.js';
import './user/notifications';
import './user/dashboard';
import './user/view_options';
import './user/videos.js';

import './admin/html_editor.js';
import './admin/group_tabelle';
import './admin/group_autocomplete.js';
import './admin/sentence_tabelle.js';
import './admin/tabellen_audio_play.js';
import './admin/texte_tabelle.js';
import './admin/user_autocomplete.js';
import './admin/words_tabelle.js';

jQuery(document).ready(function($) {

    /**
     *  Tooltips
     *  ------------------------------------------------------------------------
     */
    const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]')
    const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new bootstrap.Tooltip(tooltipTriggerEl))

    /**
     *  Date Picker
     *  ------------------------------------------------------------------------
     */
    $('form .input-group.date').datepicker({
        format: 'dd.mm.yyyy', language: 'de'
    });

    /**
     *  Help Video Modals: pause on close.
     *  ------------------------------------------------------------------------
     */
    $('.help-video-modal').on('hide.bs.modal', function(){
        $(this).find('video').get(0).pause();
    });

    /**
     *  Time Picker
     *  ------------------------------------------------------------------------
     */
    $('form .input-group.time').clockpicker();

    /**
     *  Toggle Navbar Lasche
     *  ------------------------------------------------------------------------
     */
    $('#navbar_toggle').on('click', function () {
        $(document.body).toggleClass('navbar-toggle');
    })


    /**
     *  Avatar Selection
     *  ------------------------------------------------------------------------
     */
    $('#profile_avatar .avatar-img').on('click', function () {
        $('.avatar-img, .avatar-user').removeClass('selected');
        $(this).addClass('selected');

        let userImage = $('#profile_avatar .avatar-user img');
        userImage.attr('src', $(this).attr('src'));

        $('#profile_avatar input[name="avatar"]').val($(this).data('value'));
    });

    $('#profile_avatar .avatar-user').on('click', function () {
        $('.avatar-img').removeClass('selected');
        $(this).addClass('selected');

        let userImage = $('#profile_avatar .avatar-user img');
        userImage.attr('src', userImage.data('current'));

        $('#profile_avatar input[name="avatar"]').val($(this).data('value'));
    });

    /**
     *  Toggle Password Peek
     *  ------------------------------------------------------------------------
     */
    $('#passwordToggle').on('click', function() {
        let $input = $('#current_password');
        let $icon = $(this);

        // Determine the current type
        const isPassword = $input.attr('type') === 'password';

        // Toggle type
        $input.attr('type', isPassword ? 'text' : 'password');

        // Toggle icon
        $icon.toggleClass('bi-eye-slash-fill bi-eye-fill');
    });


    /**
     *  Account Design Settings Preview
     *  ------------------------------------------------------------------------
     */
    // Set a prefix rule: prefer 'name', fallback to 'id'
    function getPrefix($el) {
        return $el.attr('name') || $el.attr('id') || 'unknown';
    }

    // Collect all select/input values and apply as classes
    function updateExerciseClasses() {
        const classes = [];

        $('.preview-controls select').each(function () {
            const $el = $(this);
            const val = $el.val();
            const prefix = getPrefix($el);

            console.log(prefix, val);

            // For checkbox: only when checked, use value or 'checked'
            if ($el.is(':checkbox')) {
                if ($el.is(':checked')) {
                    classes.push(prefix + '-' + (val || 'checked'));
                }
                // unchecked: don't add class
            } else if (val && val.length > 0) {
                // For other types (ignore empty)
                classes.push(prefix + '-' + val);
            }
        });

        const $exc = $('#exercise');
        $exc.removeAttr('class');
        $exc.addClass('text-body text-focus ' + classes.join(' '));
    }

    // Observe change/input events
    $('.preview-controls').on('change input', 'select', updateExerciseClasses);


});
